import {
  API_ENDPOINTS,
  ApiResponse,
  MasterArea,
  CreateMasterAreaDto,
  UpdateMasterAreaDto
} from '../api';
import httpClient from '../httpClient';

export const masterAreaService = {
  getList: async (params?: { search?: string; page?: number; limit?: number }) => {
    try {
      const response = await httpClient.get<ApiResponse<MasterArea>>(
        API_ENDPOINTS.MASTER_AREA.LIST,
        {
          params: {
            pageNumber: params?.page || 1,
            pageSize: params?.limit || 100,
            search: params?.search || ''
          }
        }
      );
      return response.data;
    } catch {
      return {
        pageNumber: params?.page || 1,
        pageSize: params?.limit || 100,
        totalPages: 0,
        totalRecords: 0,
        message: 'Failed to fetch data',
        data: []
      };
    }
  },

  getDetail: async (id: string) => {
    const response = await httpClient.get(API_ENDPOINTS.MASTER_AREA.DETAIL(id));
    return response.data;
  },

  create: async (data: CreateMasterAreaDto) => {
    const response = await httpClient.post(API_ENDPOINTS.MASTER_AREA.CREATE, data);
    return response.data;
  },

  update: async (data: UpdateMasterAreaDto) => {
    const response = await httpClient.put(API_ENDPOINTS.MASTER_AREA.UPDATE, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await httpClient.delete(API_ENDPOINTS.MASTER_AREA.DELETE, {
      data: { areaID: id }
    });
    return response.data;
  }
};
